import { px } from "./stylesUtils";
export var getModeSpace = function getModeSpace(spacing, mode) {
  return px(spacing / (mode === 'dense' ? 2 : 1));
};
export var getThemeSpace = function getThemeSpace(_ref, defaultSpace) {
  var mode = _ref.mode,
      selectors = _ref.selectors;
  var gap = selectors.space(defaultSpace);

  if (!gap) {
    return defaultSpace;
  }

  return getModeSpace(gap, mode);
};